import React from 'react';
import {Text, TouchableOpacity, StyleSheet} from 'react-native';
import {Colors} from '../../../constants/Colors';
import ProductCarouselShell from './ProductCarouselShell';
import {useBagStore} from '../../../store/BagStore';
import SuggestedFillService, {
  SuggestedFillItem,
} from '../../../services/SuggestedFillService';

interface SuggestedCarouselProps {
  products: any[] | null;
  loading: boolean;
  onAddBag: (product: any, quantity: number) => void;
  onOpenProduct: (product: any) => void;
  onSeeAll: () => void;
  clientCode?: string;
}

const SuggestedCarousel: React.FC<SuggestedCarouselProps> = ({
  clientCode,
  products,
  loading,
  onAddBag,
  onOpenProduct,
  onSeeAll,
}) => {
  const {products: bagProducts} = useBagStore();

  const handleAddAll = () => {
    if (!products) return;
    let added = 0;
    const snapshot: SuggestedFillItem[] = [];

    products.forEach(item => {
      const suggestion = item?.suggestion_qtd || 0;
      if (item?.sku && suggestion > 0) {
        snapshot.push({sku: item.sku, quantity: Number(suggestion)});
      }
      const existingProduct = bagProducts.find(p => p.sku === item?.sku);
      if (!existingProduct || existingProduct.quantity < suggestion) {
        onAddBag(item, suggestion);
        added += 1;
      }
    });

    // Marca a sacola: o pedido que sair dela vai como pedido sugerido.
    if (added > 0) {
      SuggestedFillService.registerSuggestedFill(
        clientCode,
        'home_carousel',
        snapshot,
      );
    }
  };

  const addAllButton = products && products.length > 0 ? (
    <TouchableOpacity onPress={handleAddAll} style={styles.addAllButton}>
      <Text style={styles.addAllText}>Adicionar Todos</Text>
    </TouchableOpacity>
  ) : null;

  return (
    <ProductCarouselShell
      title="Pedido Sugerido"
      products={products}
      loading={loading}
      onSeeAll={onSeeAll}
      seeAllLabel="Ver todos"
      onAddBag={onAddBag}
      onOpenProduct={onOpenProduct}
      headerRight={addAllButton}
      useLegacyCard
    />
  );
};

const styles = StyleSheet.create({
  addAllButton: {
    marginRight: 4,
  },
  addAllText: {
    color: Colors.RedPallete.red,
    fontWeight: 'bold',
    fontSize: 13,
  },
});

export default React.memo(SuggestedCarousel);
